import { render, staticRenderFns } from "./CreateShipping.vue?vue&type=template&id=6c105033&"
import script from "./CreateShipping.vue?vue&type=script&lang=js&"
export * from "./CreateShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports